import Vue from "vue";
import App from "./App.vue";
// import router from "./router";
import router from "./starterRouter";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'
import VueScrollTo from 'vue-scrollto';
import animateCss from "animate.css";
import devicon from "devicon";

Vue.config.productionTip = true;
Vue.use(Argon);
Vue.use(animateCss);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -50,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
Vue.use(devicon)

new Vue({
  router,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount("#app");
